<template>
  <div class="dashboard-block">
    <form>
      <h2>Notifications</h2>

      <div class="row row-clear-md-4">
        <div class="col-md-4">
          <div :class="$hasErrorClass($v.stateBillboardPostLength, 'form-group')">
            <label class="control-label">Billboard posting length</label>
            <div class="input-group">
              <input
                name="billboard_post_length"
                type="number"
                class="form-control"
                v-model.lazy="$v.stateBillboardPostLength.$model">
              <span class="input-group-addon">days</span>
            </div>

            <vuelidate-help label="Billboard post length" :field="$v.stateBillboardPostLength"/>
          </div>
        </div>

        <div class="col-md-4">
          <div :class="$hasErrorClass($v.stateDepositPaymentWarningAdmin, 'form-group')">
            <label class="control-label">Deposit payment warning for admin</label>
            <div class="input-group">
              <input
                name="deposit_payment_warning_admin"
                type="number"
                class="form-control"
                v-model.lazy="$v.stateDepositPaymentWarningAdmin.$model">
              <span class="input-group-addon">days</span>
            </div>

            <vuelidate-help label="Deposit warning notification for admin" :field="$v.stateDepositPaymentWarningAdmin" />
          </div>
        </div>

        <div class="col-md-4">
          <div :class="$hasErrorClass($v.stateDepositPaymentWarningClient, 'form-group')">
            <label class="control-label">Deposit payment warning for client</label>
            <div class="input-group">
              <input
                name="deposit_payment_warning_client"
                type="number"
                class="form-control"
                v-model.lazy="$v.stateDepositPaymentWarningClient.$model">
              <span class="input-group-addon">days</span>
            </div>

            <vuelidate-help label="Deposit warning notification for client" :field="$v.stateDepositPaymentWarningClient" />
          </div>
        </div>

        <div class="col-md-4">
          <div :class="$hasErrorClass($v.stateFinalPaymentWarningAdmin, 'form-group')">
            <label class="control-label">Final payment warning for admin</label>
            <div class="input-group">
              <input
                name="final_payment_warning_admin"
                type="number"
                class="form-control"
                v-model.lazy="$v.stateFinalPaymentWarningAdmin.$model">
              <span class="input-group-addon">days</span>
            </div>

            <vuelidate-help label="Final payment warning for client" :field="$v.stateFinalPaymentWarningAdmin" />
          </div>
        </div>

        <div class="col-md-4">
          <div :class="$hasErrorClass($v.stateFinalPaymentWarningClient, 'form-group')">
            <label class="control-label">Final payment warning for client</label>
            <div class="input-group">
              <input
                name="final_payment_warning_client"
                type="number"
                class="form-control"
                v-model.lazy="$v.stateFinalPaymentWarningClient.$model">
              <span class="input-group-addon">days</span>
            </div>

            <vuelidate-help label="Final payment warning for client" :field="$v.stateFinalPaymentWarningClient" />
          </div>
        </div>

        <div class="col-md-4">
          <div :class="$hasErrorClass($v.stateInitialTalentReminder, 'form-group')">
            <label class="control-label">Initial reminder for {{ $starLabelPlural }}</label>
            <div class="input-group">
              <input
                name="initial_talent_reminder"
                type="number"
                class="form-control"
                v-model.lazy="$v.stateInitialTalentReminder.$model">
              <span class="input-group-addon">days</span>
            </div>

            <vuelidate-help label="Initial talent reminder" :field="$v.stateInitialTalentReminder" />
          </div>
        </div>

        <div class="col-md-4">
          <div :class="$hasErrorClass($v.stateSecondTalentReminder, 'form-group')">
            <label class="control-label">Second reminder for {{ $starLabelPlural }} with response</label>
            <div class="input-group">
              <input
                name="second_talent_reminder"
                type="number"
                class="form-control"
                v-model.lazy="$v.stateSecondTalentReminder.$model">
              <span class="input-group-addon">days</span>
            </div>

            <vuelidate-help label="Second talent reminder" :field="$v.stateInitialTalentReminder" />
          </div>
        </div>

        <div class="col-md-4">
          <div :class="$hasErrorClass($v.stateFinalTalentReminder, 'form-group')">
            <label class="control-label">Final reminder for {{ $starLabelPlural }}</label>
            <div class="input-group">
              <input
                name="final_talent_reminder"
                type="number"
                class="form-control"
                v-model.lazy="$v.stateFinalTalentReminder.$model">
              <span class="input-group-addon">hours</span>
            </div>

            <vuelidate-help label="Final talent reminder" :field="$v.stateSecondTalentReminder" />
          </div>
        </div>
      </div>

      <ladda-button
        class="btn btn-success"
        :click="handleSaveNotificationSettingsCallback">
        <i class="fa fa-check"></i> Save Changes
      </ladda-button>
    </form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import { stateMapper } from 'mixins/settings'
import { pick } from 'lodash'
import VuelidateHelp from '../misc/VuelidateHelp'
import { notify } from 'utils'

export default {
  components: { VuelidateHelp },
  mixins: [stateMapper],

  validations: {
    stateBillboardPostLength: {
      required
    },
    stateDepositPaymentWarningAdmin: {
      required
    },
    stateDepositPaymentWarningClient: {
      required
    },
    stateFinalPaymentWarningAdmin: {
      required
    },
    stateFinalPaymentWarningClient: {
      required
    },
    stateInitialTalentReminder: {
      required
    },
    stateSecondTalentReminder: {
      required
    },
    stateFinalTalentReminder: {
      required
    }
  },

  methods: {
    ...mapActions('settings', ['updateSettings']),

    handleSaveNotificationSettingsCallback () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        notify.error(`Some fields failed validation. Please fix them and try again`)
        return Promise.resolve()
      }
      return this.updateSettings(pick(this.settings, [
        'billboard_post_length',
        'deposit_payment_warning_admin',
        'deposit_payment_warning_client',
        'final_payment_warning_admin',
        'final_payment_warning_client',
        'initial_talent_reminder',
        'second_talent_reminder',
        'final_talent_reminder'
      ]))
    }
  }
}
</script>
